export default {

    data: {
        formSubmitted: false,
    },

    mounted () {
        this.handleFormSuccess()
    },

    methods: {
        handleFormSuccess () {
            const { sproutFormContainer } = this.$refs

            if (sproutFormContainer) {
                const sproutForm = sproutFormContainer.querySelector('form')

                sproutForm.addEventListener('afterSproutFormsSubmit', () => {
                    this.formSubmitted = true
                    const scrollPoint = sproutFormContainer.getBoundingClientRect().top + document.documentElement.scrollTop
                    window.scrollTo({
                        top: scrollPoint - 100,
                        left: 0,
                        behavior: 'smooth',
                    })
                }, false)
            }
        },
    },

}
